import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import autoBind from 'react-autobind'
import { Link } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'
import ActionButtons from '.././home/ActionButtons';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  articlesList: PropTypes.any,
}

class ShowArticles extends Component {
  constructor(){
    super();
    autoBind(this);
  }
render(){
  const {articlesList} = this.props
  
  const tableStyles = {
    stripedRows: true,
    displaySelectAll: false,
    adjustForCheckbox: false,
    selectable: false,
    displayRowCheckbox: false,
  }
  return(
    <div>
      <h2>Articles</h2>
      <div style={{marginLeft: '20px'}} className="action-buttons">
        <Link to="/articles/new">
          <RaisedButton
            label="Add New Article"
            primary
          />
        </Link>
      </div>
      <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn>Title</TableHeaderColumn>
              <TableHeaderColumn>Summary</TableHeaderColumn>
              <TableHeaderColumn>Date Created</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            { articlesList && articlesList.map((article, i) => {
              var options = { month: 'long', day: 'numeric', year: 'numeric'}
              const date = new Date(article.createdAt)
              const formattedDate = date.toLocaleDateString("en-US", options)
                return <TableRow key={i}>
                        <TableRowColumn key={i}>{article.title}</TableRowColumn>
                        <TableRowColumn key={i}>{article.summary}</TableRowColumn>
                        <TableRowColumn key={i}>{formattedDate}</TableRowColumn>
                        <TableRowColumn key={i}>
                          <ActionButtons
                            onEdit={`/articles/${article.id}`}
                          />
                        </TableRowColumn>
                      </TableRow>
              })}
          </TableBody>
        </Table> 
    </div>
  )
}
}

ShowArticles.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    articlesList: state.articles.articlesList,
  };
}

export default connect(mapStateToProps)(ShowArticles)


// WEBPACK FOOTER //
// ./src/components/Articles/ShowArticles.js